<template>
    <div>
        <div class="center fs18" style="padding-top: 40px;">
            <p class="black fs32 fw500">{{ $t('price1') }}</p>
            <span class="backyel dib divide"></span>
            <div :class="{left: isEng, p1: true}" >
                <p class="mb30 center">{{ $t('price2') }}</p>
                <p class="mb30 center">{{ $t('price3') }}</p>
                <p class="mb30 center">{{ $t('price4') }}</p>
                <p class="mb30 center">{{ $t('price5') }}</p>
                <p class="mb30 center">{{ $t('price6') }}</p>
                <p class="mb30 center">{{ $t('price7') }}</p>
				<p class="mb30 center">{{ $t('price8') }}</p>
				<p class="mb30 center">{{ $t('price9') }}</p>
				<p class="mb30 center">{{ $t('price10') }}</p>
				<p class="mb30 center">{{ $t('price11') }}</p>
				<p class="mb30 center">{{ $t('price12') }}</p>
            </div>
        </div>
        <div :class="$style.w">
        <!-- <div class="f1"></div> -->
        <div class="dflex acsb1 fw" >
            <div :class="$style.card" class="bb">
				<!-- <img src="../assets/sd-Deng.png" alt="" :class="$style.sdhat"> -->
                <div class="backblack center" style="padding: 40px 0px;">
                    <p class="white fs18 mb30 fw500">{{ row2[1].name }}</p>
                    <p class="yel fs32 fw500">{{ $t('money') }} ${{row2[1].price}}</p>
                </div>
                <div class="backgray fs14 mb30">
                    <p style="padding: 30px 40px;" class="fw500">{{ row2[1].desc }}</p>
                    <ul :class="$style.list" class="gray" style="padding: 0 20px 40px 20px;">
                        <li>{{ $t('p3') }}</li>
                        <li>{{ $t('p4') }}</li>
                        <li>{{ $t('a1') }}</li>
                        <li>{{ $t('p16') }}</li>
                        <li>{{ $t('a2') }}</li>
                        <!-- <li>{{ $t('p10') }}</li> -->
                        <!-- <li>{{ $t('p7') }}</li> -->
                    </ul>
                </div>
            </div>
            <div :class="$style.card" class="bb" v-for="item in row1" :key="item.name">
				<!-- <img src="../assets/sd-Deng.png" alt="" :class="$style.sdhat"> -->
                <div class="backblack center" style="padding: 40px 0px;">
                    <p class="white fs18 mb30 fw500">{{ item.name }}</p>
                    <p class="yel fs32 fw500">{{ $t('money') }} ${{item.price}}</p>
                </div>
                <div class="backgray fs14">
                    <p style="padding: 30px 40px;" class="fw500">{{ item.desc }}</p>
                    <ul :class="$style.list" class="gray" style="padding: 0 20px 40px 20px;">
                        <li>{{ $t('p3') }}</li>
                        <li>{{ $t('p4') }}</li>
                        <li>{{ $t('p5') }}</li>
                        <li>{{ $t('p6') }}</li>
                        <li>{{ $t('p7') }}</li>
                        <li>{{ $t('p8') }}</li>
                        <li>{{ $t('p9') }}</li>
                        <li>{{ $t('p10') }}</li>
                        <li v-if="$t('p11')">{{ $t('p11') }}</li>
                        <li>{{ $t('p111') }}</li>
                    </ul>
                </div>
            </div>
            <div :class="$style.card" class="bb">
				<!-- <img src="../assets/sd-Deng.png" alt="" :class="$style.sdhat"> -->
                <div class="backblack center" style="padding: 40px 0px;">
                    <p class="white fs18 mb30 fw500">{{ row2[0].name }}</p>
                    <p class="yel fs32 fw500">{{ $t('money') }} ${{row2[0].price}}</p>
                </div>
                <div class="backgray fs14 mb30">
                    <p style="padding: 30px 40px;" class="fw500">{{ row2[0].desc }}</p>
                    <ul :class="$style.list" class="gray" style="padding: 0 20px 40px 20px;">
                        <li>{{ $t('p3') }}</li>
                        <li>{{ $t('p4') }}</li>
                        <li>{{ $t('a1') }}</li>
                        <li>{{ $t('p16') }}</li>
                        <li>{{ $t('a2') }}</li>
                        <!-- <li>{{ $t('p10') }}</li> -->
                        <!-- <li>{{ $t('p7') }}</li> -->
                    </ul>
                </div>
            </div>
            <!-- <div :class="$style.card" class="bb">
                <div class="backblack center" style="padding: 40px 0px;">
                    <p class="white fs18 mb30 fw500">{{ $t('p14') }}</p>
                    <p class="yel fs32 fw500">{{ $t('money') }} $2500</p>
                </div>
                <div class="backgray fs14">
                    <p style="padding: 30px 40px;" class="fw500">{{ $t('p15') }}</p>
                    <ul :class="$style.list" class="gray" style="padding: 0 20px 40px 20px;">
                        <li>{{ $t('p3') }}</li>
                        <li>{{ $t('p4') }}</li>
                        <li>{{ $t('a1') }}</li>
                        <li>{{ $t('p16') }}</li>
                        <li>{{ $t('a2') }}</li>
                    </ul>
                </div>
            </div>
            <div :class="$style.card" class="bb">
                <div class="backblack center" style="padding: 40px 0px;">
                    <p class="white fs18 mb30 fw500">{{ $t('p17') }}</p>
                    <p class="yel fs32 fw500">{{ $t('money') }} $1680</p>
                </div>
                <div class="backgray fs14">
                    <p style="padding: 30px 40px;" class="fw500">{{ $t('p151') }}</p>
                    <ul :class="$style.list" class="gray" style="padding: 0 20px 40px 20px;">
                        <li>{{ $t('p3') }}</li>
                        <li>{{ $t('p4') }}</li>
                        <li>{{ $t('a1') }}</li>
                        <li>{{ $t('p16') }}</li>
                    </ul>
                </div>
            </div> -->
            <div :class="$style.card" class="bb">
				<!-- <img src="../assets/sd-Deng.png" alt="" :class="$style.sdhat"> -->
                <div class="backblack center" style="padding: 40px 0px;">
                    <p class="yel fs32 fw500">{{ $t('insu') }}</p>
                </div>
                <div class="backgray fs14 gray">
                    <div style="padding: 30px 20px;">
                        <p class="fw500">{{ $t('cname') }}</p>
                        <p class='mb30'>{{ $t('cname1') }}</p>
                        <p class="dflex">
                            <span>{{ $t('ty') }}</span>
                            <span class="yel f1 right">{{ $t('money') }} $1280</span>
                        </p>
                    </div>
                    <div class="center black fw500" style="padding: 50px;">
                        <ubutton :text="$t('df')" :download="true" :href="$service.insurance"></ubutton>
                    </div>
                </div>
            </div>
            <div :class="$style.card" class="backgray center cp" style="padding-top:50px;" @click="goWhatsapp">
                <img src="../assets/whatsapp.png" width="80">
                <p class="fs16 fw500" style="margin-top: 30px;">{{ $t('wa') }}</p>
                <div class="fs14 left" style="margin: 30px;padding-left: 30px;">
                    <p>{{ $t('worktime') }}</p>
                    <p>{{ $t('worktime1') }}</p>
                </div>
            </div>
            <!-- <div :class="$style.card">
                <uwhatsapp></uwhatsapp>
            </div> -->
            <div :class="$style.card" class="showInLarge"></div>
        </div>
        <!-- <div class="f1"></div> -->
            <div class="dflex showInLargef" style="margin-top: 30px;margin-bottom: -40px;    padding: 0px 30px;">
                <!-- <div class="dflex"> -->
                    <img src="../assets/p2.png" alt="" :class="$style.img">
                    <div class="f1 dflex fcenter">
                        <img src="../assets/p1.png" alt="" :class="$style.img" style="position: relative;height: 120px;top: -15px;">
                    </div>
                    <img src="../assets/LOGO_LabourD3.png" alt="" :class="$style.img">
                <!-- </div> -->
            </div>
        </div>
        <div class="showInSmallb center fc" style="margin: 20px auto;">
            <img src="../assets/p1.png" alt="" :class="$style.img1">
            <br/>
            <img src="../assets/p2.png" alt="" :class="$style.img">
            <br/>
            <img src="../assets/LOGO_LabourD3.png" alt="" :class="$style.img">
        </div>
    </div>
</template>
<script>
import {priceMap} from '../data.js';

export default {
    name: 'Price',
    data() {
        return {
            isEng: this.$i18n.locale === 'en',
            row1: [
                {name: this.$t('pp3'), price: priceMap[3], desc: this.$t('pp4')},
                {name: this.$t('pp2'), price: priceMap[2], desc: this.$t('p21')},
                {name: this.$t('p1'), price: priceMap[1], desc: this.$t('p2') },
                {name: this.$t('p12'), price: priceMap[4], desc: this.$t('p13')},
            ],
            row2: [
                {name: this.$t('p18'), price: priceMap[6], desc: this.$t('p181')},
                {name: this.$t('p17'), price: priceMap[5], desc: this.$t('p15')},
            ],
        }
    },
    created() {
        this.$top();
    }
}
</script>
<style module>
.list {
    list-style: none;
}
.list > li:before {
    content: "\02022";
    color: #eeb40ad1;
    font-size: 16px;
    padding-right: 10px;
}
.card {
    width: 280px;
    margin: 40px 30px;
	position: relative;
}

/* 圣诞 */
/* .sdhat{
	position: absolute;
	right: -120px;
	top: -90px;
} */
/* 新年 */
.sdhat{
	position: absolute;
	right: -33px;
	top: -33px;
}
.img {
    /* width: 200px; */
    height: 90px;
    margin: 10px 20px;
}
.w {
    margin: 0px 100px;
}
@media screen and (max-width: 770px) {
    .card {
        margin-bottom: 10px;
    }
    .img1 {
        height: 70px;
        width: 70px;
    }
    .img {
        height: 50px;
        margin-top: 20px;
    }
    .w {
        margin: 0 20px;
    }
}
</style>
